import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import { LoadUserNotification, SaveUserNotification } from '../action/notification.action';
import type { NotificationState } from '../state/notification.state';
import { initialNotificationState } from '../state/notification.state';

const notificationReducer = createReducer(
  initialNotificationState,
  on(SaveUserNotification, (state: NotificationState, { userNotification }) => ({ ...state, userNotification })),
);

export function NotificationReducer(state: NotificationState | undefined, action: Action): NotificationState {
  return notificationReducer(state, action);
}
